function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useMemo, useCallback } from 'react';
import moment from 'moment';
import { Box, Button, Icon, icons, Menu, MenuButton, MenuList, MenuItemOption, MenuOptionGroup, Text } from '@tapresearch/ui/components';
import { WAVES_VIEW_OPTIONS } from './';
var WAVES_VIEW_LABELS = {
    all: 'All waves',
    last4: 'Last 4 waves',
    last12: 'Last 12 waves'
};
export var WaveTimelineSelect = function(param) {
    var waves = param.waves, wavesView = param.wavesView, onChangeWavesView = param.onChangeWavesView;
    var numWaves = waves.length;
    var getWaves = useCallback(function() {
        switch(wavesView.option){
            case WAVES_VIEW_OPTIONS.all:
                {
                    return [
                        waves[0],
                        waves[numWaves - 1]
                    ];
                }
            case WAVES_VIEW_OPTIONS.last4:
                {
                    return [
                        waves[0],
                        numWaves >= 4 ? waves[3] : waves[numWaves - 1]
                    ];
                }
            case WAVES_VIEW_OPTIONS.last12:
                {
                    return [
                        waves[0],
                        numWaves >= 12 ? waves[11] : waves[numWaves - 1]
                    ];
                }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(waves),
        wavesView,
        numWaves
    ]);
    var waveDateDisplayValue = useMemo(function() {
        var _getWaves = _sliced_to_array(getWaves(), 2), lastWave = _getWaves[0], firstWave = _getWaves[1];
        return {
            short: "".concat(moment(firstWave.attributes.launch_date).format('MMM Do, YYYY'), " - ").concat(moment(lastWave.attributes.launch_date).format('MMM Do, YYYY')),
            long: "".concat(moment(firstWave.attributes.launch_date).format('MMMM Do, YYYY'), " - ").concat(moment(lastWave.attributes.launch_date).format('MMMM Do, YYYY'))
        };
    }, [
        getWaves
    ]);
    return /*#__PURE__*/ React.createElement(Menu, {
        isLazy: true,
        autoSelect: false
    }, /*#__PURE__*/ React.createElement(MenuButton, {
        as: Button,
        "data-testid": "wave-timeline-select-trigger",
        variant: "ghost",
        fontWeight: "medium",
        colorScheme: "gray",
        color: "gray.600",
        rightIcon: /*#__PURE__*/ React.createElement(Icon, {
            icon: icons.fi.ChevronDown
        })
    }, waveDateDisplayValue.long), /*#__PURE__*/ React.createElement(MenuList, {
        "data-testid": "wave-timeline-select-menu",
        sx: {
            '.chakra-menu__icon-wrapper': {
                d: 'none'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        py: 2,
        px: 4,
        color: "gray.700",
        fontWeight: "medium",
        borderBottom: "1px solid",
        borderBottomColor: "gray.200"
    }, /*#__PURE__*/ React.createElement(Text, {
        as: Box,
        fontSize: "xs"
    }, WAVES_VIEW_LABELS[wavesView.option]), /*#__PURE__*/ React.createElement(Text, {
        as: Box,
        py: 2,
        fontSize: "sm"
    }, waveDateDisplayValue.short)), /*#__PURE__*/ React.createElement(Box, {
        p: 3
    }, /*#__PURE__*/ React.createElement(MenuOptionGroup, {
        onChange: onChangeWavesView,
        defaultValue: wavesView.option,
        type: "radio"
    }, /*#__PURE__*/ React.createElement(MenuItemOption, _object_spread_props(_object_spread({}, Styles.MenuItem, wavesView.option === WAVES_VIEW_OPTIONS.all && _object_spread({}, Styles.MenuItemSelected)), {
        value: WAVES_VIEW_OPTIONS.all
    }), "All waves"), /*#__PURE__*/ React.createElement(MenuItemOption, _object_spread_props(_object_spread({}, Styles.MenuItem, wavesView.option === WAVES_VIEW_OPTIONS.last4 && _object_spread({}, Styles.MenuItemSelected), numWaves < 5 && {
        isDisabled: true
    }), {
        value: WAVES_VIEW_OPTIONS.last4
    }), "Last 4 waves"), /*#__PURE__*/ React.createElement(MenuItemOption, _object_spread_props(_object_spread({}, Styles.MenuItem, wavesView.option === WAVES_VIEW_OPTIONS.last12 && _object_spread({}, Styles.MenuItemSelected), numWaves < 13 && {
        isDisabled: true
    }), {
        value: WAVES_VIEW_OPTIONS.last12
    }), "Last 12 waves")))));
};
var Styles = {
    MenuItem: {
        rounded: 'md',
        fontSize: 'md',
        fontWeight: 'medium',
        color: 'gray.500',
        mb: 1,
        _focus: {
            bg: 'blue.50'
        },
        _hover: {
            bg: 'blue.50'
        }
    },
    MenuItemSelected: {
        bg: 'blue.50',
        color: 'blue.500'
    }
};
